import { createApp, pinia } from './vue';

import cardCarousel from './vue/apps/card-carousel';

const cardCarouselMountingContainer = document.querySelectorAll('.js-card-carousel-container');

if (cardCarouselMountingContainer) {
    const cardCarousels = [];

    cardCarouselMountingContainer.forEach((el) => {
        const app = createApp(cardCarousel).use(pinia).mount(el);
        cardCarousels.push(app);
    });
}
